// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__TPADQ","logo":"Logo_logo__2FriI","subLogo":"Logo_subLogo__vsbzS"};